module.exports = __webpack_public_path__ + "media/images/rebate_grey-9d85fc861c8af6a1facbb5d0309dcd79.png";